import { Component, HostListener, Input, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { faCog } from '@fortawesome/free-solid-svg-icons';
import { AuthService } from '../../../services/auth/auth.service';
import { SecurityService } from '../../../../_security/services/security/security.service';
import { User } from '../../../../_security/models/security.models';
import { AppConfig } from '../../../../app.config';
import { Subject } from 'rxjs/Subject';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'pt-nav',
  templateUrl: './nav.component.html',
  styleUrls: ['./nav.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class NavComponent implements OnInit, OnDestroy {
  @Input() title: string;

  user: User;
  displayName: string;
  environmentLabel: string;
  logoUrl: string;
  optionsOpen: boolean = false;
  loggedIn: boolean = false;

  navOptionsElement;
  settingsIcon = faCog;
  private destroy$: Subject<any> = new Subject();

  @HostListener('document:click', ['$event'])
  click(event) {
    if (!this.navOptionsElement) {
      this.navOptionsElement = document.getElementById('nav-options-dropdown-container');
    }

    const optionClicked = event.target.classList.contains('option');

    if (this.optionsOpen && this.navOptionsElement && (optionClicked || !this.navOptionsElement.contains(event.target))) {
      this.optionsOpen = false;
    }
  }

  constructor(
    private router: Router,
    private authService: AuthService,
    private securityService: SecurityService
  ) {
    this.environmentLabel = AppConfig.settings.environmentName;
    this.title = AppConfig.settings.appName;
    this.logoUrl = AppConfig.settings.logoUrl;
  }

  ngOnInit() {
    this.updateLoggedInState();

    this.authService.authStateChange$
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => this.updateLoggedInState());
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  logout() {
    this.authService.logout();
    this.router.navigate([AppConfig.settings.auth.loginRoute]);
  }

  private updateLoggedInState(): void {
    this.loggedIn = this.authService.isAuthenticated;
    this.displayName = this.authService.currentUserDisplayName();

    if (!this.loggedIn) {
      this.user = null;
      this.securityService.clearUser();
      this.optionsOpen = false;
      return;
    }

    this.securityService.getUser().subscribe(user => {
      this.user = user;
      const fullName = `${user.firstName || ''} ${user.lastName || ''}`.trim();
      this.displayName = fullName || user.username || this.displayName;
    }, () => {
      this.displayName = this.authService.currentUserDisplayName();
    });
  }
}
